import { Badge, BadgeProps } from '@mui/material';

interface IProps {
  children?: React.ReactNode;
}

const BadgeWrapper: React.FC<IProps & BadgeProps> = ({ children, ...props }) => <Badge {...props}>{children}</Badge>;

export type { BadgeProps };
export default BadgeWrapper;
